export const feedbackFormValidationMap: Record<string, Record<string, string | ((error: any) => string)>> = {
    transactionQuestion: {
        required: 'Please select Yes or No.',
    },

    transaction: {
        required: 'Please select Merger, Consolidation, or Acquisition.',
    },

    reasons: {
        required: 'Please select at least one reason.',
    },

    othersNo: {
        required: 'Please specify other reasons.',
        maxlength: (error: any) => `Input text cannot exceed ${error.requiredLength} characters.`,
    },

    stage: {
        required: 'Please select a negotiation stage.',
    },

    stage_others: {
        required: 'Please specify the negotiation stage.',
        maxlength: (error: any) => `Input text cannot exceed ${error.requiredLength} characters.`,
    },
};
